var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-box-logo-container" }, [
    _c("img", {
      staticClass: "video-box-logo",
      class: _vm.getLogoWidth,
      style: [_vm.getCustomContentWidth],
      attrs: {
        alt: _vm.content.alt_text,
        title: _vm.content.title_text,
        src: _vm.content.image_url,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }